import PropTypes from "prop-types";
import React, { useEffect, useReducer } from "react";
import { loadItem, saveItem, removeItem } from "../Utils";

const STORAGE_KEY = "valut-color-mode";

const readStoredMode = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "dark" || stored === "light") return stored;
  } catch {
    // ignore
  }

  const legacy = loadItem("userTheme");
  if (legacy === "dark" || legacy === "light") return legacy;

  return "light";
};

const applyDocumentClass = (mode) => {
  const root = document.documentElement;
  if (mode === "dark") {
    root.classList.add("dark");
  } else {
    root.classList.remove("dark");
  }
  root.style.colorScheme = mode === "dark" ? "dark" : "light";
};

const persistMode = (mode) => {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // ignore
  }
  saveItem(mode, "userTheme");
};

const currentTheme = readStoredMode();
applyDocumentClass(currentTheme);

const reducer = (state, action) => {
  switch (action.type) {
    case "setUserTheme": {
      persistMode(action.userTheme);
      applyDocumentClass(action.userTheme);
      return action.userTheme;
    }
    case "clear": {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch {
        // ignore
      }
      removeItem("userTheme");
      applyDocumentClass("light");
      return "light";
    }
    default:
      throw new Error("Unexpected action");
  }
};

export const ThemeContext = React.createContext();

const Provider = ({ children }) => {
  const context = useReducer(reducer, currentTheme);

  useEffect(() => {
    applyDocumentClass(context[0]);
  }, [context[0]]);

  return (
    <ThemeContext.Provider value={context}>{children}</ThemeContext.Provider>
  );
};

Provider.defaultProps = {
  children: <></>,
};

Provider.propTypes = {
  children: PropTypes.node,
};

export default Provider;
